import * as PropTypes from 'prop-types';
import * as React from 'react';
import CanadianBankFields from './canadian_bank_fields';
import USBankFields from './us_bank_fields';
import AustralianBankFields from './australian_bank_fields';
import UKBankFields from './uk_bank_fields';
import EUBankFields from './eu_bank_fields';

class BankAccountFieldsSelector extends React.Component {
  constructor() {
    super();

    this.usBankFields = this.usBankFields.bind(this);
    this.canadianBankFields = this.canadianBankFields.bind(this);
    this.australianBankFields = this.australianBankFields.bind(this);
    this.ukBankFields = this.ukBankFields.bind(this);
  }

  euBankFields() {
    return (
      <EUBankFields
        data-country-form-eu
        countryCodeOptions={this.props.countryCodeOptions}
        nameForField={this.props.nameForField}
        onCountryChange={this.props.onCountryChange}
        currencies={this.props.currencies}
        dashboardView={this.props.dashboardView}
        bankCountry={this.props.selectedBankCountry}
      />
    );
  }

  ukBankFields() {
    return (
      <UKBankFields
        data-country-form-uk
        countryCodeOptions={this.props.countryCodeOptions}
        nameForField={this.props.nameForField}
        onCountryChange={this.props.onCountryChange}
        onCurrencyChange={this.props.onCurrencyChange}
        currencies={this.props.currencies}
        dashboardView={this.props.dashboardView}
        selectedPayoutCurrency={this.props.selectedPayoutCurrency}
      />
    );
  }

  australianBankFields() {
    return (
      <AustralianBankFields
        data-country-form-au
        countryCodeOptions={this.props.countryCodeOptions}
        nameForField={this.props.nameForField}
        onCountryChange={this.props.onCountryChange}
        currencies={this.props.currencies}
        dashboardView={this.props.dashboardView}
      />
    );
  }

  canadianBankFields() {
    return (
      <CanadianBankFields
        data-country-form-ca
        bankLookupUrl={this.props.bankLookupUrl}
        nameForField={this.props.nameForField}
        onCountryChange={this.props.onCountryChange}
        onCurrencyChange={this.props.onCurrencyChange}
        countryCodeOptions={this.props.countryCodeOptions}
        currencies={this.props.currencies}
        selectedPayoutCurrency={this.props.selectedPayoutCurrency}
        shopCurrency={this.props.shopCurrency}
        dashboardView={this.props.dashboardView}
      />
    );
  }

  usBankFields() {
    return (
      <USBankFields
        data-country-form-us
        bankLookupUrl={this.props.bankLookupUrl}
        nameForField={this.props.nameForField}
        onCountryChange={this.props.onCountryChange}
        countryCodeOptions={this.props.countryCodeOptions}
        selectedPayoutCurrency={this.props.selectedPayoutCurrency}
        shopCurrency={this.props.shopCurrency}
        dashboardView={this.props.dashboardView}
        currencies={this.props.currencies}
      />
    );
  }

  render() {
    const bankFields = {
      US: this.usBankFields,
      CA: this.canadianBankFields,
      AU: this.australianBankFields,
      GB: this.ukBankFields,
    };

    if (bankFields[this.props.selectedBankCountry]) {
      return bankFields[this.props.selectedBankCountry]();
    }

    return this.euBankFields();
  }
}

BankAccountFieldsSelector.propTypes = {
  selectedBankCountry: PropTypes.string.isRequired,
  bankLookupUrl: PropTypes.string,
  nameForField: PropTypes.func,
  onCountryChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  countryCodeOptions: PropTypes.array,
  currencies: PropTypes.array,
  selectedPayoutCurrency: PropTypes.string,
  shopCurrency: PropTypes.string,
  dashboardView: PropTypes.bool,
};

export default BankAccountFieldsSelector;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile/bank_account_fields/bank_account_fields_selector.jsx